// Lightweight logger that only emits in dev. Avoids leaking internal state
// in production bundles while keeping debuggability locally.
const isDev =
  typeof process !== "undefined" &&
  process?.env?.NODE_ENV !== "production";

export const logWarn = (...args) => {
  if (isDev && typeof console !== "undefined") {
    console.warn(...args);
  }
};

export const logError = (...args) => {
  if (isDev && typeof console !== "undefined") {
    console.error(...args);
  }
};
